export const getNodePath = (focusedNode) => {
    let pathname
    if (focusedNode === null || focusedNode.length === 0) {
        pathname = `/ciods`
    } else {
        pathname = `/ciods/${focusedNode.join('/')}`
    }
    return { pathname }
}
